<div class="modal-header">
    <h4 class="modal-title">Export to Vista</h4>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-sm-12 col-12">
            <p>Choose the date range of fuel records to export to Vista.</p>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="vistaStartDate">Start Date</label>
                <input id="vistaStartDate" type="date" class="form-control" [(ngModel)]="startDate" name="startDate" />
            </div>
        </div>
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="vistaEndDate">End Date</label>
                <input id="vistaEndDate" type="date" class="form-control" [(ngModel)]="endDate" name="endDate" />
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button id="btnVistaExport" type="button" class="btn btn-primary" (click)="export()">Export</button>
    <button id="btnVistaCancel" type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
</div>
